import React from 'react';

function PriceBox({ price, label, description }) {
    return (
        <div className="flex">
            <div className="flex-1">{label}</div>
            <div className="hidden md:block flex-1">{description}</div>
            <div className="flex-1 flex justify-end">{ price }€</div>
        </div>
    );
}

export default PriceBox;